import React from 'react'

import CollarStatusBadge from '#/components/badges/CollarStatusBadge'

const TypeCollarStatusBadge = ({ value, label }) => {
  if (!value) return <span>-</span>
  return <CollarStatusBadge value={value} label={label} />
}
export default TypeCollarStatusBadge
